import { FiberManualRecord } from '@mui/icons-material';
import { type Theme, Typography, styled, useTheme } from '@mui/material';
import { type SystemStyleObject } from '@mui/system';
import { Fragment } from 'react';

export type MetadataProps = {
  metadata: (string | number)[];
  sx?: SystemStyleObject<Theme>;
};

const Container = styled('div')();

export const Metadata = ({ metadata, sx }: MetadataProps) => {
  const theme = useTheme();

  return (
    <Container sx={sx}>
      <Typography sx={{ color: theme.supportingTextPrimary }} variant="body2">
        {metadata.map((data, index) => (
          <Fragment key={index}>
            <span>{data}</span>
            {index === metadata.length - 1 ? undefined : (
              <FiberManualRecord
                sx={{ height: '10px', marginLeft: theme.spacing(1), marginRight: theme.spacing(1), width: '10px' }}
              />
            )}
          </Fragment>
        ))}
      </Typography>
    </Container>
  );
};
